[
  {
    "Id": 1,
    "Stripe_Id": "txn_3QcV0TJZZMNTppNS1zv21it8",
    "Payment_Type": "payment",
    "Payment_Source": "py_3QcV0TJZZMNTppNS1SmmWBUl",
    "Amount": 156,
    "Currency": "eur",
    "Created_on": "2025-01-01T16:43:10",
    "Available_on": "2025-01-07T00:00:00",
    "Description": "PAYMENT DONE",
    "Remarks": "pm_1QcV0cJZZMNTppNSMrpyvZfQ",
    "Remarks2": "pi_3QcV0TJZZMNTppNS18ZARE5P",
    "Transfer_Date": "2025-01-01T16:43:10",
    "Transfer_group": "TG.98341.164222",
    "TaskId": 164222,
    "Journal": 200,
    "Ledger": "1500",
    "ShopperEmail": "merverdede@hotmail.com",
    "Payment_Dpt": "98341",
    "Status": 2,
    "Created_by": "madhu",
    "Created_date": "2025-05-13T13:46:59.517",
    "Modified_date": "2025-05-13T13:46:59.517",
    "ImportCounter": 1
  },
  {
    "Id": 2,
    "Stripe_Id": "txn_3QcT4aJZZMNTppNS0346Dggw",
    "Payment_Type": "payment",
    "Payment_Source": "py_3QcT4aJZZMNTppNS0my5Z1pq",
    "Amount": 373.75,
    "Currency": "eur",
    "Created_on": "2025-01-01T14:41:09",
    "Available_on": "2025-01-07T00:00:00",
    "Description": "PAYMENT DONE",
    "Remarks": "pm_1QcT5tJZZMNTppNSJkhUEBWU",
    "Remarks2": "pi_3QcT4aJZZMNTppNS0srQk6KT",
    "Transfer_Date": "2025-01-01T14:41:09",
    "Transfer_group": "TG.98342.164231",
    "TaskId": 164231,
    "Journal": 200,
    "Ledger": "1500",
    "ShopperEmail": "kristjanbonfoh@yahoo.com",
    "Payment_Dpt": "98342",
    "Status": 2,
    "Created_by": "madhu",
    "Created_date": "2025-05-13T13:46:59.517",
    "Modified_date": "2025-05-13T13:46:59.517",
    "ImportCounter": 1
  },
  {
    "Id": 3,
    "Stripe_Id": "txn_3QcSlRJZZMNTppNS1M6A2tFz",
    "Payment_Type": "payment",
    "Payment_Source": "py_3QcSlRJZZMNTppNS1gsGgPAB",
    "Amount": 365,
    "Currency": "eur",
    "Created_on": "2025-01-01T14:19:40",
    "Available_on": "2025-01-07T00:00:00",
    "Description": "PAYMENT DONE",
    "Remarks": "pm_1QcSleJZZMNTppNSL5JjSac0",
    "Remarks2": "pi_3QcSlRJZZMNTppNS1tKiN7po",
    "Transfer_Date": "2025-01-01T14:19:40",
    "Transfer_group": "TG.98340.163629",
    "TaskId": 163629,
    "Journal": 200,
    "Ledger": "1500",
    "ShopperEmail": "renaybrouwer@hotmail.com",
    "Payment_Dpt": "98340",
    "Status": 2,
    "Created_by": "madhu",
    "Created_date": "2025-05-13T13:46:59.517",
    "Modified_date": "2025-05-13T13:46:59.517",
    "ImportCounter": 1
  },
  {
    "Id": 4,
    "Stripe_Id": "txn_3QcSYMJZZMNTppNS0VrOlpf7",
    "Payment_Type": "payment",
    "Payment_Source": "py_3QcSYMJZZMNTppNS0Xboekki",
    "Amount": 363,
    "Currency": "eur",
    "Created_on": "2025-01-01T14:06:06",
    "Available_on": "2025-01-07T00:00:00",
    "Description": "PAYMENT DONE",
    "Remarks": "pm_1QcSYUJZZMNTppNSvzTOUCov",
    "Remarks2": "pi_3QcSYMJZZMNTppNS02uiDyEo",
    "Transfer_Date": "2025-01-01T14:06:06",
    "Transfer_group": "TG.98090.163748",
    "TaskId": 163748,
    "Journal": 200,
    "Ledger": "1500",
    "ShopperEmail": "erin.van.buel@gmail.com",
    "Payment_Dpt": "98090",
    "Status": 2,
    "Created_by": "madhu",
    "Created_date": "2025-05-13T13:46:59.517",
    "Modified_date": "2025-05-13T13:46:59.517",
    "ImportCounter": 1
  },
  {
    "Id": 5,
    "Stripe_Id": "txn_3QcRToJZZMNTppNS1KhKPFdN",
    "Payment_Type": "payment",
    "Payment_Source": "py_3QcRToJZZMNTppNS1gucVyim",
    "Amount": 124,
    "Currency": "eur",
    "Created_on": "2025-01-01T12:57:48",
    "Available_on": "2025-01-07T00:00:00",
    "Description": "PAYMENT DONE",
    "Remarks": "pm_1QcRTvJZZMNTppNSzc9FdteV",
    "Remarks2": "pi_3QcRToJZZMNTppNS1T5tKfVR",
    "Transfer_Date": "2025-01-01T12:57:48",
    "Transfer_group": "TG.98336.163926",
    "TaskId": 163926,
    "Journal": 200,
    "Ledger": "1500",
    "ShopperEmail": "mtvanschuppen@gmail.com",
    "Payment_Dpt": "98336",
    "Status": 2,
    "Created_by": "madhu",
    "Created_date": "2025-05-13T13:46:59.517",
    "Modified_date": "2025-05-13T13:46:59.517",
    "ImportCounter": 1
  },
  {
    "Id": 6,
    "Stripe_Id": "txn_3QcRKEJZZMNTppNS1Qi9dxds",
    "Payment_Type": "payment",
    "Payment_Source": "py_3QcRKEJZZMNTppNS1yMGlT6S",
    "Amount": 274,
    "Currency": "eur",
    "Created_on": "2025-01-01T12:47:21",
    "Available_on": "2025-01-07T00:00:00",
    "Description": "PAYMENT DONE",
    "Remarks": "pm_1QcRKMJZZMNTppNSP1nffVBZ",
    "Remarks2": "pi_3QcRKEJZZMNTppNS1udmdB1P",
    "Transfer_Date": "2025-01-01T12:47:21",
    "Transfer_group": "TG.98338.164077",
    "TaskId": 164077,
    "Journal": 200,
    "Ledger": "1500",
    "ShopperEmail": "miyaadaabdi@hotmail.com",
    "Payment_Dpt": "98338",
    "Status": 2,
    "Created_by": "madhu",
    "Created_date": "2025-05-13T13:46:59.517",
    "Modified_date": "2025-05-13T13:46:59.517",
    "ImportCounter": 1
  },
  {
    "Id": 7,
    "Stripe_Id": "txn_3QcslnJZZMNTppNS1kuyDhIG",
    "Payment_Type": "payment",
    "Payment_Source": "py_3QcslnJZZMNTppNS15nPextR",
    "Amount": 207.13,
    "Currency": "eur",
    "Created_on": "2025-01-02T18:06:13",
    "Available_on": "2025-01-07T00:00:00",
    "Description": "PAYMENT DONE",
    "Remarks": "pm_1QcsmOJZZMNTppNSZKXjgvcc",
    "Remarks2": "pi_3QcslnJZZMNTppNS1MM7ZqqI",
    "Transfer_Date": "2025-01-02T18:06:13",
    "Transfer_group": "TG.98385.163749",
    "TaskId": 163749,
    "Journal": 200,
    "Ledger": "1500",
    "ShopperEmail": "daisy_moreno@live.nl",
    "Payment_Dpt": "98385",
    "Status": 2,
    "Created_by": "madhu",
    "Created_date": "2025-05-13T13:48:36.897",
    "Modified_date": "2025-05-13T13:48:36.897",
    "ImportCounter": 1
  },
  {
    "Id": 8,
    "Stripe_Id": "txn_3QcsPvJZZMNTppNS0zFYEEH0",
    "Payment_Type": "payment",
    "Payment_Source": "py_3QcsPvJZZMNTppNS0maJ6GdH",
    "Amount": 152.75,
    "Currency": "eur",
    "Created_on": "2025-01-02T17:43:06",
    "Available_on": "2025-01-07T00:00:00",
    "Description": "PAYMENT DONE",
    "Remarks": "pm_1QcsQ2JZZMNTppNSRw9rG1WH",
    "Remarks2": "pi_3QcsPvJZZMNTppNS0qOCrVDQ",
    "Transfer_Date": "2025-01-02T17:43:06",
    "Transfer_group": "TG.98384.164229",
    "TaskId": 164229,
    "Journal": 200,
    "Ledger": "1500",
    "ShopperEmail": "wilbert@zwaart.eu",
    "Payment_Dpt": "98384",
    "Status": 2,
    "Created_by": "madhu",
    "Created_date": "2025-05-13T13:48:36.897",
    "Modified_date": "2025-05-13T13:48:36.897",
    "ImportCounter": 1
  },
  {
    "Id": 9,
    "Stripe_Id": "txn_3QcrSCJZZMNTppNS0in9vIoL",
    "Payment_Type": "payment",
    "Payment_Source": "py_3QcrSCJZZMNTppNS0lsm706J",
    "Amount": 380,
    "Currency": "eur",
    "Created_on": "2025-01-02T16:41:30",
    "Available_on": "2025-01-07T00:00:00",
    "Description": "PAYMENT DONE",
    "Remarks": "pm_1QcrSNJZZMNTppNSvTqMPVx3",
    "Remarks2": "pi_3QcrSCJZZMNTppNS0DYNd0E3",
    "Transfer_Date": "2025-01-02T16:41:30",
    "Transfer_group": "TG.98367.163390",
    "TaskId": 163390,
    "Journal": 200,
    "Ledger": "1500",
    "ShopperEmail": "nmvr@upcmail.nl",
    "Payment_Dpt": "98367",
    "Status": 2,
    "Created_by": "madhu",
    "Created_date": "2025-05-13T13:48:36.897",
    "Modified_date": "2025-05-13T13:48:36.897",
    "ImportCounter": 1
  },
  {
    "Id": 10,
    "Stripe_Id": "txn_3Qcr6TJZZMNTppNS0IMkbrNd",
    "Payment_Type": "payment",
    "Payment_Source": "py_3Qcr6TJZZMNTppNS0hNq7ldM",
    "Amount": 412,
    "Currency": "eur",
    "Created_on": "2025-01-02T16:19:00",
    "Available_on": "2025-01-07T00:00:00",
    "Description": "PAYMENT DONE",
    "Remarks": "pm_1Qcr6iJZZMNTppNSp8xESzNj",
    "Remarks2": "pi_3Qcr6TJZZMNTppNS0ilFlbN5",
    "Transfer_Date": "2025-01-02T16:19:00",
    "Transfer_group": "TG.98372.164239",
    "TaskId": 164239,
    "Journal": 200,
    "Ledger": "1500",
    "ShopperEmail": "davidhardenberg@outlook.com",
    "Payment_Dpt": "98372",
    "Status": 2,
    "Created_by": "madhu",
    "Created_date": "2025-05-13T13:48:36.897",
    "Modified_date": "2025-05-13T13:48:36.897",
    "ImportCounter": 1
  },
  {
    "Id": 11,
    "Stripe_Id": "txn_3QcqjVJZZMNTppNS0dqqNSjC",
    "Payment_Type": "payment",
    "Payment_Source": "py_3QcqjVJZZMNTppNS0GM33asQ",
    "Amount": 221,
    "Currency": "eur",
    "Created_on": "2025-01-02T15:55:10",
    "Available_on": "2025-01-07T00:00:00",
    "Description": "PAYMENT DONE",
    "Remarks": "pm_1QcqjcJZZMNTppNSyn2q7hbI",
    "Remarks2": "pi_3QcqjVJZZMNTppNS0TLh9Pbx",
    "Transfer_Date": "2025-01-02T15:55:10",
    "Transfer_group": "TG.98383.164177",
    "TaskId": 164177,
    "Journal": 200,
    "Ledger": "1500",
    "ShopperEmail": "hensup@planet.nl",
    "Payment_Dpt": "98383",
    "Status": 2,
    "Created_by": "madhu",
    "Created_date": "2025-05-13T13:48:36.897",
    "Modified_date": "2025-05-13T13:48:36.897",
    "ImportCounter": 1
  },
  {
    "Id": 12,
    "Stripe_Id": "txn_3QcqIsJZZMNTppNS0MrWwQxb",
    "Payment_Type": "payment",
    "Payment_Source": "py_3QcqIsJZZMNTppNS0i1NdcHW",
    "Amount": 100,
    "Currency": "eur",
    "Created_on": "2025-01-02T15:27:40",
    "Available_on": "2025-01-07T00:00:00",
    "Description": "PAYMENT DONE",
    "Remarks": "pm_1QcqJ2JZZMNTppNSdQtwoRav",
    "Remarks2": "pi_3QcqIsJZZMNTppNS0QNFO92L",
    "Transfer_Date": "2025-01-02T15:27:40",
    "Transfer_group": "TG.98060.163858",
    "TaskId": 163858,
    "Journal": 200,
    "Ledger": "1500",
    "ShopperEmail": "winge427@planet.nl",
    "Payment_Dpt": "98060",
    "Status": 2,
    "Created_by": "madhu",
    "Created_date": "2025-05-13T13:48:36.897",
    "Modified_date": "2025-05-13T13:48:36.897",
    "ImportCounter": 1
  },
  {
    "Id": 13,
    "Stripe_Id": "txn_3QcqEOJZZMNTppNS0NRx9mmy",
    "Payment_Type": "payment",
    "Payment_Source": "py_3QcqEOJZZMNTppNS07oxWwM0",
    "Amount": 110,
    "Currency": "eur",
    "Created_on": "2025-01-02T15:23:13",
    "Available_on": "2025-01-07T00:00:00",
    "Description": "PAYMENT DONE",
    "Remarks": "pm_1QcqEYJZZMNTppNSWZk2XlJp",
    "Remarks2": "pi_3QcqEOJZZMNTppNS0uYRnu0a",
    "Transfer_Date": "2025-01-02T15:23:13",
    "Transfer_group": "TG.98170.163859",
    "TaskId": 163859,
    "Journal": 200,
    "Ledger": "1500",
    "ShopperEmail": "winge427@planet.nl",
    "Payment_Dpt": "98170",
    "Status": 2,
    "Created_by": "madhu",
    "Created_date": "2025-05-13T13:48:36.897",
    "Modified_date": "2025-05-13T13:48:36.897",
    "ImportCounter": 1
  },
  {
    "Id": 14,
    "Stripe_Id": "txn_3Qcq31JZZMNTppNS0meT8PEI",
    "Payment_Type": "payment",
    "Payment_Source": "py_3Qcq31JZZMNTppNS07jeoU5M",
    "Amount": 480,
    "Currency": "eur",
    "Created_on": "2025-01-02T15:11:43",
    "Available_on": "2025-01-07T00:00:00",
    "Description": "PAYMENT DONE",
    "Remarks": "pm_1Qcq3AJZZMNTppNSyXJaV268",
    "Remarks2": "pi_3Qcq31JZZMNTppNS0Jz1dww9",
    "Transfer_Date": "2025-01-02T15:11:43",
    "Transfer_group": "TG.98346.164113",
    "TaskId": 164113,
    "Journal": 200,
    "Ledger": "1500",
    "ShopperEmail": "celebrate1st@hotmail.com",
    "Payment_Dpt": "98346",
    "Status": 2,
    "Created_by": "madhu",
    "Created_date": "2025-05-13T13:48:36.897",
    "Modified_date": "2025-05-13T13:48:36.897",
    "ImportCounter": 1
  },
  {
    "Id": 15,
    "Stripe_Id": "txn_3Qcq0NJZZMNTppNS0EhtUkdB",
    "Payment_Type": "payment",
    "Payment_Source": "py_3Qcq0NJZZMNTppNS0pac05H4",
    "Amount": 280,
    "Currency": "eur",
    "Created_on": "2025-01-02T15:09:23",
    "Available_on": "2025-01-07T00:00:00",
    "Description": "PAYMENT DONE",
    "Remarks": "pm_1Qcq0ZJZZMNTppNSo8Un4VKe",
    "Remarks2": "pi_3Qcq0NJZZMNTppNS0Rv65l3l",
    "Transfer_Date": "2025-01-02T15:09:23",
    "Transfer_group": "TG.98381.164050",
    "TaskId": 164050,
    "Journal": 200,
    "Ledger": "1500",
    "ShopperEmail": "7682696@gmail.com",
    "Payment_Dpt": "98381",
    "Status": 2,
    "Created_by": "madhu",
    "Created_date": "2025-05-13T13:48:36.897",
    "Modified_date": "2025-05-13T13:48:36.897",
    "ImportCounter": 1
  },
  {
    "Id": 16,
    "Stripe_Id": "txn_3QcpyEJZZMNTppNS06aMxIaV",
    "Payment_Type": "payment",
    "Payment_Source": "py_3QcpyEJZZMNTppNS0sfSopIl",
    "Amount": 388,
    "Currency": "eur",
    "Created_on": "2025-01-02T15:07:43",
    "Available_on": "2025-01-07T00:00:00",
    "Description": "PAYMENT DONE",
    "Remarks": "pm_1QcpyhJZZMNTppNS3qeddsCh",
    "Remarks2": "pi_3QcpyEJZZMNTppNS0XMn8q2N",
    "Transfer_Date": "2025-01-02T15:07:43",
    "Transfer_group": "TG.98377.164245",
    "TaskId": 164245,
    "Journal": 200,
    "Ledger": "1500",
    "ShopperEmail": "m_q_lyl@163.com",
    "Payment_Dpt": "98377",
    "Status": 2,
    "Created_by": "madhu",
    "Created_date": "2025-05-13T13:48:36.897",
    "Modified_date": "2025-05-13T13:48:36.897",
    "ImportCounter": 1
  },
  {
    "Id": 17,
    "Stripe_Id": "txn_3QcpmuJZZMNTppNS0SC5qnQM",
    "Payment_Type": "payment",
    "Payment_Source": "py_3QcpmuJZZMNTppNS0iC2NntT",
    "Amount": 416.5,
    "Currency": "eur",
    "Created_on": "2025-01-02T14:54:46",
    "Available_on": "2025-01-07T00:00:00",
    "Description": "PAYMENT DONE",
    "Remarks": "pm_1Qcpn4JZZMNTppNSs3A5Yh4s",
    "Remarks2": "pi_3QcpmuJZZMNTppNS03JOIkWo",
    "Transfer_Date": "2025-01-02T14:54:46",
    "Transfer_group": "TG.98378.162800",
    "TaskId": 162800,
    "Journal": 200,
    "Ledger": "1500",
    "ShopperEmail": "chrisaten68@gmail.com",
    "Payment_Dpt": "98378",
    "Status": 2,
    "Created_by": "madhu",
    "Created_date": "2025-05-13T13:48:36.897",
    "Modified_date": "2025-05-13T13:48:36.897",
    "ImportCounter": 1
  },
  {
    "Id": 18,
    "Stripe_Id": "txn_3QcpklJZZMNTppNS13yerF0k",
    "Payment_Type": "payment",
    "Payment_Source": "py_3QcpklJZZMNTppNS1tgccbOs",
    "Amount": 90,
    "Currency": "eur",
    "Created_on": "2025-01-02T14:52:18",
    "Available_on": "2025-01-07T00:00:00",
    "Description": "PAYMENT DONE",
    "Remarks": "pm_1QcpkqJZZMNTppNS18eU8xXp",
    "Remarks2": "pi_3QcpklJZZMNTppNS1n9FVGIc",
    "Transfer_Date": "2025-01-02T14:52:18",
    "Transfer_group": "TG.98380.164248",
    "TaskId": 164248,
    "Journal": 200,
    "Ledger": "1500",
    "ShopperEmail": "lisachante@outlook.com",
    "Payment_Dpt": "98380",
    "Status": 2,
    "Created_by": "madhu",
    "Created_date": "2025-05-13T13:48:36.897",
    "Modified_date": "2025-05-13T13:48:36.897",
    "ImportCounter": 1
  },
  {
    "Id": 19,
    "Stripe_Id": "txn_3QcpUDJZZMNTppNS1afGBb1A",
    "Payment_Type": "payment",
    "Payment_Source": "py_3QcpUDJZZMNTppNS1qxqrJs0",
    "Amount": 219,
    "Currency": "eur",
    "Created_on": "2025-01-02T14:36:19",
    "Available_on": "2025-01-07T00:00:00",
    "Description": "PAYMENT DONE",
    "Remarks": "pm_1QcpUOJZZMNTppNSjv9TZPAu",
    "Remarks2": "pi_3QcpUDJZZMNTppNS1fOJnyR2",
    "Transfer_Date": "2025-01-02T14:36:19",
    "Transfer_group": "TG.98141.163696",
    "TaskId": 163696,
    "Journal": 200,
    "Ledger": "1500",
    "ShopperEmail": "l.apeldoorn@tabijn.nl",
    "Payment_Dpt": "98141",
    "Status": 2,
    "Created_by": "madhu",
    "Created_date": "2025-05-13T13:48:36.897",
    "Modified_date": "2025-05-13T13:48:36.897",
    "ImportCounter": 1
  },
  {
    "Id": 20,
    "Stripe_Id": "txn_3QcpJnJZZMNTppNS0CEFDyGI",
    "Payment_Type": "payment",
    "Payment_Source": "py_3QcpJnJZZMNTppNS0Xr491wT",
    "Amount": 215,
    "Currency": "eur",
    "Created_on": "2025-01-02T14:24:48",
    "Available_on": "2025-01-07T00:00:00",
    "Description": "PAYMENT DONE",
    "Remarks": "pm_1QcpJvJZZMNTppNSWVxa4PXa",
    "Remarks2": "pi_3QcpJnJZZMNTppNS0v7GSRPW",
    "Transfer_Date": "2025-01-02T14:24:48",
    "Transfer_group": "TG.98375.164085",
    "TaskId": 164085,
    "Journal": 200,
    "Ledger": "1500",
    "ShopperEmail": "parcheleo@gmail.com",
    "Payment_Dpt": "98375",
    "Status": 2,
    "Created_by": "madhu",
    "Created_date": "2025-05-13T13:48:36.897",
    "Modified_date": "2025-05-13T13:48:36.897",
    "ImportCounter": 1
  },
  {
    "Id": 21,
    "Stripe_Id": "txn_3QcpGuJZZMNTppNS1DY4s82W",
    "Payment_Type": "payment",
    "Payment_Source": "py_3QcpGuJZZMNTppNS1HZ0FJY4",
    "Amount": 870,
    "Currency": "eur",
    "Created_on": "2025-01-02T14:21:53",
    "Available_on": "2025-01-07T00:00:00",
    "Description": "PAYMENT DONE",
    "Remarks": "pm_1QcpHAJZZMNTppNSdhPBTJjI",
    "Remarks2": "pi_3QcpGuJZZMNTppNS18fpoh2s",
    "Transfer_Date": "2025-01-02T14:21:53",
    "Transfer_group": "TG.98374.163643",
    "TaskId": 163643,
    "Journal": 200,
    "Ledger": "1500",
    "ShopperEmail": "ahmed.kalsekar@gmail.com",
    "Payment_Dpt": "98374",
    "Status": 2,
    "Created_by": "madhu",
    "Created_date": "2025-05-13T13:48:36.897",
    "Modified_date": "2025-05-13T13:48:36.897",
    "ImportCounter": 1
  },
  {
    "Id": 22,
    "Stripe_Id": "txn_3QcpDxJZZMNTppNS04pRxFJZ",
    "Payment_Type": "payment",
    "Payment_Source": "py_3QcpDxJZZMNTppNS0WswbtYH",
    "Amount": 1521.5,
    "Currency": "eur",
    "Created_on": "2025-01-02T14:18:34",
    "Available_on": "2025-01-07T00:00:00",
    "Description": "PAYMENT DONE",
    "Remarks": "pm_1QcpE6JZZMNTppNSWK44SvMi",
    "Remarks2": "pi_3QcpDxJZZMNTppNS0VVMzBBR",
    "Transfer_Date": "2025-01-02T14:18:34",
    "Transfer_group": "TG.98373.163532",
    "TaskId": 163532,
    "Journal": 200,
    "Ledger": "1500",
    "ShopperEmail": "ashwin.vandervlugt@hotmail.com",
    "Payment_Dpt": "98373",
    "Status": 2,
    "Created_by": "madhu",
    "Created_date": "2025-05-13T13:48:36.897",
    "Modified_date": "2025-05-13T13:48:36.897",
    "ImportCounter": 1
  },
  {
    "Id": 23,
    "Stripe_Id": "txn_3Qcp0nJZZMNTppNS0MYFAcsb",
    "Payment_Type": "payment",
    "Payment_Source": "py_3Qcp0nJZZMNTppNS0170t8BM",
    "Amount": 186,
    "Currency": "eur",
    "Created_on": "2025-01-02T14:04:45",
    "Available_on": "2025-01-07T00:00:00",
    "Description": "PAYMENT DONE",
    "Remarks": "pm_1Qcp0sJZZMNTppNSaJo2xcdm",
    "Remarks2": "pi_3Qcp0nJZZMNTppNS0zsXglZR",
    "Transfer_Date": "2025-01-02T14:04:45",
    "Transfer_group": "TG.98320.163974",
    "TaskId": 163974,
    "Journal": 200,
    "Ledger": "1500",
    "ShopperEmail": "kalkidan1996@hotmail.com",
    "Payment_Dpt": "98320",
    "Status": 2,
    "Created_by": "madhu",
    "Created_date": "2025-05-13T13:48:36.897",
    "Modified_date": "2025-05-13T13:48:36.897",
    "ImportCounter": 1
  },
  {
    "Id": 24,
    "Stripe_Id": "txn_3QcoynJZZMNTppNS14O8ZdT6",
    "Payment_Type": "payment",
    "Payment_Source": "py_3QcoynJZZMNTppNS1wpYFOHC",
    "Amount": 350,
    "Currency": "eur",
    "Created_on": "2025-01-02T14:03:07",
    "Available_on": "2025-01-07T00:00:00",
    "Description": "PAYMENT DONE",
    "Remarks": "pm_1QcoywJZZMNTppNSKv7hzcwN",
    "Remarks2": "pi_3QcoynJZZMNTppNS16Sndgw0",
    "Transfer_Date": "2025-01-02T14:03:07",
    "Transfer_group": "TG.98359.162402",
    "TaskId": 162402,
    "Journal": 200,
    "Ledger": "1500",
    "ShopperEmail": "jolette_langeveld@hotmail.com",
    "Payment_Dpt": "98359",
    "Status": 2,
    "Created_by": "madhu",
    "Created_date": "2025-05-13T13:48:36.897",
    "Modified_date": "2025-05-13T13:48:36.897",
    "ImportCounter": 1
  },
  {
    "Id": 25,
    "Stripe_Id": "txn_3QcodfJZZMNTppNS1992bl9T",
    "Payment_Type": "payment",
    "Payment_Source": "py_3QcodfJZZMNTppNS1SMqaTl9",
    "Amount": 312.5,
    "Currency": "eur",
    "Created_on": "2025-01-02T13:41:19",
    "Available_on": "2025-01-07T00:00:00",
    "Description": "PAYMENT DONE",
    "Remarks": "pm_1QcodxJZZMNTppNSNwMqH3vq",
    "Remarks2": "pi_3QcodfJZZMNTppNS11WiijZf",
    "Transfer_Date": "2025-01-02T13:41:19",
    "Transfer_group": "TG.98371.164140",
    "TaskId": 164140,
    "Journal": 200,
    "Ledger": "1500",
    "ShopperEmail": "megmierlo@hotmail.com",
    "Payment_Dpt": "98371",
    "Status": 2,
    "Created_by": "madhu",
    "Created_date": "2025-05-13T13:48:36.897",
    "Modified_date": "2025-05-13T13:48:36.897",
    "ImportCounter": 1
  },
  {
    "Id": 26,
    "Stripe_Id": "txn_3QcoXsJZZMNTppNS041n3yzS",
    "Payment_Type": "payment",
    "Payment_Source": "py_3QcoXsJZZMNTppNS0KQP6VbL",
    "Amount": 115,
    "Currency": "eur",
    "Created_on": "2025-01-02T13:35:34",
    "Available_on": "2025-01-07T00:00:00",
    "Description": "PAYMENT DONE",
    "Remarks": "pm_1QcoYZJZZMNTppNSzVrBFcB0",
    "Remarks2": "pi_3QcoXsJZZMNTppNS0G8QHwY4",
    "Transfer_Date": "2025-01-02T13:35:34",
    "Transfer_group": "TG.98370.163972",
    "TaskId": 163972,
    "Journal": 200,
    "Ledger": "1500",
    "ShopperEmail": "StephanHuurman@visio.org",
    "Payment_Dpt": "98370",
    "Status": 2,
    "Created_by": "madhu",
    "Created_date": "2025-05-13T13:48:36.897",
    "Modified_date": "2025-05-13T13:48:36.897",
    "ImportCounter": 1
  },
  {
    "Id": 27,
    "Stripe_Id": "txn_3QcoV0JZZMNTppNS0XD4flli",
    "Payment_Type": "payment",
    "Payment_Source": "py_3QcoV0JZZMNTppNS0WjA4brF",
    "Amount": 89.5,
    "Currency": "eur",
    "Created_on": "2025-01-02T13:32:38",
    "Available_on": "2025-01-07T00:00:00",
    "Description": "PAYMENT DONE",
    "Remarks": "pm_1QcoVLJZZMNTppNS5BwcD3Eo",
    "Remarks2": "pi_3QcoV0JZZMNTppNS0q1c6NKV",
    "Transfer_Date": "2025-01-02T13:32:38",
    "Transfer_group": "TG.98369.163766",
    "TaskId": 163766,
    "Journal": 200,
    "Ledger": "1500",
    "ShopperEmail": "wout46@gmail.com",
    "Payment_Dpt": "98369",
    "Status": 2,
    "Created_by": "madhu",
    "Created_date": "2025-05-13T13:48:36.897",
    "Modified_date": "2025-05-13T13:48:36.897",
    "ImportCounter": 1
  },
  {
    "Id": 28,
    "Stripe_Id": "txn_3QcoKsJZZMNTppNS1NUsGJuv",
    "Payment_Type": "payment",
    "Payment_Source": "py_3QcoKsJZZMNTppNS1GsVkrXv",
    "Amount": 71.8,
    "Currency": "eur",
    "Created_on": "2025-01-02T13:21:50",
    "Available_on": "2025-01-07T00:00:00",
    "Description": "PAYMENT DONE",
    "Remarks": "pm_1QcoLFJZZMNTppNS2hlWalW0",
    "Remarks2": "pi_3QcoKsJZZMNTppNS1iV9MEp9",
    "Transfer_Date": "2025-01-02T13:21:50",
    "Transfer_group": "TG.98350.164124",
    "TaskId": 164124,
    "Journal": 200,
    "Ledger": "1500",
    "ShopperEmail": "gertjanmodderman@gmail.com",
    "Payment_Dpt": "98350",
    "Status": 2,
    "Created_by": "madhu",
    "Created_date": "2025-05-13T13:48:36.897",
    "Modified_date": "2025-05-13T13:48:36.897",
    "ImportCounter": 1
  },
  {
    "Id": 29,
    "Stripe_Id": "txn_3QcoFaJZZMNTppNS0zuHdt71",
    "Payment_Type": "payment",
    "Payment_Source": "py_3QcoFaJZZMNTppNS0z7Qt1M2",
    "Amount": 95,
    "Currency": "eur",
    "Created_on": "2025-01-02T13:16:02",
    "Available_on": "2025-01-07T00:00:00",
    "Description": "PAYMENT DONE",
    "Remarks": "pm_1QcoFgJZZMNTppNSWIlkYlYX",
    "Remarks2": "pi_3QcoFaJZZMNTppNS0qwZEZ0o",
    "Transfer_Date": "2025-01-02T13:16:02",
    "Transfer_group": "TG.97662.161474",
    "TaskId": 161474,
    "Journal": 200,
    "Ledger": "1500",
    "ShopperEmail": "rayan_khoesial@hotmail.com",
    "Payment_Dpt": "97662",
    "Status": 2,
    "Created_by": "madhu",
    "Created_date": "2025-05-13T13:48:36.897",
    "Modified_date": "2025-05-13T13:48:36.897",
    "ImportCounter": 1
  },
  {
    "Id": 30,
    "Stripe_Id": "txn_3QcoDEJZZMNTppNS0DlhiQXK",
    "Payment_Type": "payment",
    "Payment_Source": "py_3QcoDEJZZMNTppNS0gD6VIkA",
    "Amount": 179.75,
    "Currency": "eur",
    "Created_on": "2025-01-02T13:14:21",
    "Available_on": "2025-01-07T00:00:00",
    "Description": "PAYMENT DONE",
    "Remarks": "pm_1QcoDYJZZMNTppNSSZKz1hal",
    "Remarks2": "pi_3QcoDEJZZMNTppNS09i2FYi0",
    "Transfer_Date": "2025-01-02T13:14:21",
    "Transfer_group": "TG.98358.164234",
    "TaskId": 164234,
    "Journal": 200,
    "Ledger": "1500",
    "ShopperEmail": "malagangadin_w@hotmail.com",
    "Payment_Dpt": "98358",
    "Status": 2,
    "Created_by": "madhu",
    "Created_date": "2025-05-13T13:48:36.897",
    "Modified_date": "2025-05-13T13:48:36.897",
    "ImportCounter": 1
  },
  {
    "Id": 31,
    "Stripe_Id": "txn_1Qco5WJZZMNTppNSo9MuAZWu",
    "Payment_Type": "payout",
    "Payment_Source": "po_1Qco5WJZZMNTppNSyHqrd2O9",
    "Amount": -10000,
    "Currency": "eur",
    "Created_on": "2025-01-02T13:05:22",
    "Available_on": "2025-01-02T13:05:22",
    "Description": "",
    "Remarks": "",
    "Remarks2": "",
    "Transfer_Date": "2025-01-02T13:05:22",
    "Transfer_group": "",
    "TaskId": 0,
    "Journal": 200,
    "Ledger": "2099",
    "ShopperEmail": "",
    "Payment_Dpt": "",
    "Status": 2,
    "Created_by": "madhu",
    "Created_date": "2025-05-13T13:48:36.897",
    "Modified_date": "2025-05-13T13:48:36.897",
    "ImportCounter": 1
  },
  {
    "Id": 32,
    "Stripe_Id": "txn_3QcnusJZZMNTppNS01LFItNn",
    "Payment_Type": "payment",
    "Payment_Source": "py_3QcnusJZZMNTppNS0kerjcgP",
    "Amount": 242.13,
    "Currency": "eur",
    "Created_on": "2025-01-02T12:55:19",
    "Available_on": "2025-01-07T00:00:00",
    "Description": "PAYMENT DONE",
    "Remarks": "pm_1QcnvIJZZMNTppNSeG7ubCcu",
    "Remarks2": "pi_3QcnusJZZMNTppNS0ScDqg6x",
    "Transfer_Date": "2025-01-02T12:55:19",
    "Transfer_group": "TG.98366.164133",
    "TaskId": 164133,
    "Journal": 200,
    "Ledger": "1500",
    "ShopperEmail": "heidi.m.dewit@gmail.com",
    "Payment_Dpt": "98366",
    "Status": 2,
    "Created_by": "madhu",
    "Created_date": "2025-05-13T13:48:36.897",
    "Modified_date": "2025-05-13T13:48:36.897",
    "ImportCounter": 1
  },
  {
    "Id": 33,
    "Stripe_Id": "txn_3Qcnj3JZZMNTppNS08b94dBj",
    "Payment_Type": "payment",
    "Payment_Source": "py_3Qcnj3JZZMNTppNS0ZydpYPR",
    "Amount": 290,
    "Currency": "eur",
    "Created_on": "2025-01-02T12:43:35",
    "Available_on": "2025-01-07T00:00:00",
    "Description": "PAYMENT DONE",
    "Remarks": "pm_1QcnkJJZZMNTppNSCIquoxO3",
    "Remarks2": "pi_3Qcnj3JZZMNTppNS0vbLP8Oc",
    "Transfer_Date": "2025-01-02T12:43:35",
    "Transfer_group": "TG.98364.164251",
    "TaskId": 164251,
    "Journal": 200,
    "Ledger": "1500",
    "ShopperEmail": "sbaauch@outlook.com",
    "Payment_Dpt": "98364",
    "Status": 2,
    "Created_by": "madhu",
    "Created_date": "2025-05-13T13:48:36.897",
    "Modified_date": "2025-05-13T13:48:36.897",
    "ImportCounter": 1
  },
  {
    "Id": 34,
    "Stripe_Id": "txn_3Qcnc8JZZMNTppNS1kFPBPR1",
    "Payment_Type": "payment",
    "Payment_Source": "py_3Qcnc8JZZMNTppNS1YfFtDMs",
    "Amount": 151,
    "Currency": "eur",
    "Created_on": "2025-01-02T12:35:23",
    "Available_on": "2025-01-07T00:00:00",
    "Description": "PAYMENT DONE",
    "Remarks": "pm_1QcncFJZZMNTppNSG2cTUqyM",
    "Remarks2": "pi_3Qcnc8JZZMNTppNS1EEB5HAr",
    "Transfer_Date": "2025-01-02T12:35:23",
    "Transfer_group": "TG.98349.163874",
    "TaskId": 163874,
    "Journal": 200,
    "Ledger": "1500",
    "ShopperEmail": "lindadevet@gmail.com",
    "Payment_Dpt": "98349",
    "Status": 2,
    "Created_by": "madhu",
    "Created_date": "2025-05-13T13:48:36.897",
    "Modified_date": "2025-05-13T13:48:36.897",
    "ImportCounter": 1
  },
  {
    "Id": 35,
    "Stripe_Id": "txn_3Qcn4eJZZMNTppNS0dgLFrOk",
    "Payment_Type": "payment",
    "Payment_Source": "py_3Qcn4eJZZMNTppNS09U20qYh",
    "Amount": 134,
    "Currency": "eur",
    "Created_on": "2025-01-02T12:01:21",
    "Available_on": "2025-01-07T00:00:00",
    "Description": "PAYMENT DONE",
    "Remarks": "pm_1Qcn5QJZZMNTppNSQydwj5Bw",
    "Remarks2": "pi_3Qcn4eJZZMNTppNS04zMPnBs",
    "Transfer_Date": "2025-01-02T12:01:21",
    "Transfer_group": "TG.98361.164155",
    "TaskId": 164155,
    "Journal": 200,
    "Ledger": "1500",
    "ShopperEmail": "mateusz.kuzak@gmail.com",
    "Payment_Dpt": "98361",
    "Status": 2,
    "Created_by": "madhu",
    "Created_date": "2025-05-13T13:48:36.897",
    "Modified_date": "2025-05-13T13:48:36.897",
    "ImportCounter": 1
  },
  {
    "Id": 36,
    "Stripe_Id": "txn_3QcmmBJZZMNTppNS0D2Mctyf",
    "Payment_Type": "payment",
    "Payment_Source": "py_3QcmmBJZZMNTppNS0ymvI6hD",
    "Amount": 215,
    "Currency": "eur",
    "Created_on": "2025-01-02T11:41:42",
    "Available_on": "2025-01-07T00:00:00",
    "Description": "PAYMENT DONE",
    "Remarks": "pm_1QcmmLJZZMNTppNSS3eaJaix",
    "Remarks2": "pi_3QcmmBJZZMNTppNS00KF2YzG",
    "Transfer_Date": "2025-01-02T11:41:42",
    "Transfer_group": "TG.98356.163967",
    "TaskId": 163967,
    "Journal": 200,
    "Ledger": "1500",
    "ShopperEmail": "richardgroenewout@hotmail.com",
    "Payment_Dpt": "98356",
    "Status": 2,
    "Created_by": "madhu",
    "Created_date": "2025-05-13T13:48:36.897",
    "Modified_date": "2025-05-13T13:48:36.897",
    "ImportCounter": 1
  },
  {
    "Id": 37,
    "Stripe_Id": "txn_3QcmaUJZZMNTppNS16EPBcC6",
    "Payment_Type": "payment",
    "Payment_Source": "py_3QcmaUJZZMNTppNS1wZ976Q2",
    "Amount": 1202,
    "Currency": "eur",
    "Created_on": "2025-01-02T11:29:34",
    "Available_on": "2025-01-07T00:00:00",
    "Description": "PAYMENT DONE",
    "Remarks": "pm_1QcmadJZZMNTppNSmIhdB8HL",
    "Remarks2": "pi_3QcmaUJZZMNTppNS1IMXAMFg",
    "Transfer_Date": "2025-01-02T11:29:34",
    "Transfer_group": "TG.98354.164020",
    "TaskId": 164020,
    "Journal": 200,
    "Ledger": "1500",
    "ShopperEmail": "meladem@hotmail.com",
    "Payment_Dpt": "98354",
    "Status": 2,
    "Created_by": "madhu",
    "Created_date": "2025-05-13T13:48:36.897",
    "Modified_date": "2025-05-13T13:48:36.897",
    "ImportCounter": 1
  },
  {
    "Id": 38,
    "Stripe_Id": "txn_3QcmWEJZZMNTppNS1gvkHWId",
    "Payment_Type": "payment",
    "Payment_Source": "py_3QcmWEJZZMNTppNS1NrSMCoJ",
    "Amount": 357.5,
    "Currency": "eur",
    "Created_on": "2025-01-02T11:25:11",
    "Available_on": "2025-01-07T00:00:00",
    "Description": "PAYMENT DONE",
    "Remarks": "pm_1QcmWMJZZMNTppNSgQ6RkRuJ",
    "Remarks2": "pi_3QcmWEJZZMNTppNS160s9ZJQ",
    "Transfer_Date": "2025-01-02T11:25:11",
    "Transfer_group": "TG.98353.164253",
    "TaskId": 164253,
    "Journal": 200,
    "Ledger": "1500",
    "ShopperEmail": "y.goedhart@hotmail.com",
    "Payment_Dpt": "98353",
    "Status": 2,
    "Created_by": "madhu",
    "Created_date": "2025-05-13T13:48:36.897",
    "Modified_date": "2025-05-13T13:48:36.897",
    "ImportCounter": 1
  },
  {
    "Id": 39,
    "Stripe_Id": "txn_3Qcm9ZJZZMNTppNS1v1W30OU",
    "Payment_Type": "payment",
    "Payment_Source": "py_3Qcm9ZJZZMNTppNS1eZtBg4B",
    "Amount": 148,
    "Currency": "eur",
    "Created_on": "2025-01-02T11:01:48",
    "Available_on": "2025-01-07T00:00:00",
    "Description": "PAYMENT DONE",
    "Remarks": "pm_1Qcm9gJZZMNTppNS5IMfbvGy",
    "Remarks2": "pi_3Qcm9ZJZZMNTppNS1zu2hZmR",
    "Transfer_Date": "2025-01-02T11:01:48",
    "Transfer_group": "TG.98355.164061",
    "TaskId": 164061,
    "Journal": 200,
    "Ledger": "1500",
    "ShopperEmail": "dijkema@kpnmail.nl",
    "Payment_Dpt": "98355",
    "Status": 2,
    "Created_by": "madhu",
    "Created_date": "2025-05-13T13:48:36.897",
    "Modified_date": "2025-05-13T13:48:36.897",
    "ImportCounter": 1
  },
  {
    "Id": 40,
    "Stripe_Id": "txn_3Qcm84JZZMNTppNS0xGNwsSJ",
    "Payment_Type": "payment",
    "Payment_Source": "py_3Qcm84JZZMNTppNS0S2HXsC5",
    "Amount": 335,
    "Currency": "eur",
    "Created_on": "2025-01-02T11:00:52",
    "Available_on": "2025-01-07T00:00:00",
    "Description": "PAYMENT DONE",
    "Remarks": "pm_1Qcm8GJZZMNTppNSzPJwaT5r",
    "Remarks2": "pi_3Qcm84JZZMNTppNS0Qjt8Wpi",
    "Transfer_Date": "2025-01-02T11:00:52",
    "Transfer_group": "TG.98331.163833",
    "TaskId": 163833,
    "Journal": 200,
    "Ledger": "1500",
    "ShopperEmail": "yvonne.vandam@planet.nl",
    "Payment_Dpt": "98331",
    "Status": 2,
    "Created_by": "madhu",
    "Created_date": "2025-05-13T13:48:36.897",
    "Modified_date": "2025-05-13T13:48:36.897",
    "ImportCounter": 1
  }
]
